<template>
  <div class="detail">
    <div class="reject" v-if="(form.status == -1 || form.status == 3) && form.reject_reason && form.reject_reason != ''">
      <van-field
        class="reject-reason"
        v-model="form.reject_reason"
        :readonly="disabled"
        name="name"
        label="作废（退回）原因"
        placeholder=""
      />
    </div>
      <van-field
        v-if="form.id && form.id != 0"
        v-model="form.id"
        :disabled="disabled"
        label="申请id"
        placeholder=""
      />
      <van-field
        v-model="form.name"
        :disabled="disabled"
        name="name"
        label="姓名"
        placeholder="需和银行账户的户名一致"
      />
      <van-field
        v-model="form.id_number"
        :disabled="disabled"
        name="id_number"
        label="身份证号"
        placeholder="身份证号"
      />
      <van-field
        v-model="form.telephone"
        :disabled="disabled"
        name="telephone"
        label="手机号"
        type="digit"
        placeholder="手机号"
      />
      <van-field
        v-model="form.bank_name"
        :disabled="disabled"
        name="bank_name"
        label="银行开户行"
      />
      <van-field
        v-model="form.bank_card_no"
        name="bank_card_no"
        :disabled="disabled"
        label="银行卡号"
      />
      <van-field
        v-model="form.bank_card_telephone"
        name="bank_card_telephone"
        :disabled="disabled"
        label="银行账户预留手机号"
      />
      <van-field v-model="form.photo_id_front" name="photo_id_front" label="身份证照片（正面）" :disabled="disabled" >
        <template #input>
          <div class="upload-icon" >
            <van-image class="upload-icon" :src="form.photo_id_front" @click="preview(form.photo_id_front)">
            </van-image>
          </div>
        </template>
      </van-field>
      <van-field v-model="form.photo_id_reverse" name="photo_id_reverse" label="身份证照片（背面）" :disabled="disabled" >
        <template #input>
          <div class="upload-icon">
            <van-image class="upload-icon" :src="form.photo_id_reverse" @click="preview(form.photo_id_reverse)">
            </van-image>
          </div>
        </template>
      </van-field>
      <van-divider>报废车辆信息</van-divider>
      <van-field name="emission" v-model="form.emission" label="报废车辆排放" :disabled="disabled" :rules="[{ required: true, message: '请填选择' }]">
        <template #input>
          <van-radio-group :disabled="disabled" v-model="form.emission" direction="horizontal">
            <van-radio name="1">国四</van-radio>
            <van-radio name="2">国五</van-radio>
            <van-radio name="3">国六</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="form.scrap_car_serial_no"
        :disabled="disabled"
        name="scrap_car_serial_no"
        label="报废车辆识别代号"
      />
      <van-field
        v-model="form.scrap_car_no"
        :disabled="disabled"
        name="scrap_car_no"
        label="报废车辆车牌号"
      />
      <van-field
        v-model="form.scrap_evidence_no"
        :disabled="disabled"
        name="scrap_evidence_no"
        label="报废车辆回收证明编号"
      />
      <van-field
        readonly
        :disabled="disabled"
        name="scrap_car_back_date"
        :value="form.scrap_car_back_date"
        label="报废车辆交车日期"
      />
      <van-field
        v-model="form.scrap_car_back_location"
        :disabled="disabled"
        label="报废车辆回收地"
      />
      <van-field
        :disabled="disabled"
        name="scrap_car_regist_date"
        :value="form.scrap_car_regist_date"
        label="报废车辆注册登记日期"
      />
      <van-field
        :disabled="disabled"
        name="scrap_car_logout_date"
        :value="form.scrap_car_logout_date"
        label="报废车辆注销日期"
      />
      <van-field
        v-model="form.scrap_car_regist_location"
        :disabled="disabled"
        label="报废车辆登记地"
      />
      <van-field v-model="form.photo_scrap_car_evidence" name="photo_scrap_car_evidence" label="报废机动车回收证明" :disabled="disabled" >
        <template #input>
          <div class="upload-icon" >
            <van-image class="upload-icon" :src="form.photo_scrap_car_evidence" @click="preview(form.photo_scrap_car_evidence)">
            </van-image>
          </div>
        </template>
      </van-field>
      <van-field v-model="form.photo_scrap_car_logout_evidence" name="photo_scrap_car_logout_evidence" label="报废车辆注销证明" :disabled="disabled" >
        <template #input>
          <div class="upload-icon">
            <van-image class="upload-icon" :src="form.photo_scrap_car_logout_evidence" @click="preview(form.photo_scrap_car_logout_evidence)">
            </van-image>
          </div>
        </template>
      </van-field>
      <van-divider>新车信息</van-divider>
      <van-field name="new_car_type" v-model="form.new_car_type" label="新车类型" :disabled="disabled" >
        <template #input>
          <van-radio-group :disabled="disabled" v-model="form.new_car_type" direction="horizontal">
            <van-radio name="1">新能源车</van-radio>
            <van-radio name="2">国六B以上燃油车</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="form.car_price"
        :disabled="disabled"
        name="car_price"
        label="新车购车价格/元(不含税)"
        type="number"
      >
        <template slot="right-icon">
          (不含税)
        </template>
      </van-field>
      <van-field
        v-model="form.new_car_serial_no"
        :disabled="disabled"
        name="new_car_serial_no"
        label="新车车辆识别代号"
      />
      <van-field
        v-model="form.new_car_no"
        :disabled="disabled"
        name="new_car_no"
        label="新车车牌号"
      />
      <van-field
        v-model="form.new_car_invoice_no"
        :disabled="disabled"
        name="new_car_invoice_no"
        label="新车发票代码"
      />
      <van-field
        :disabled="disabled"
        name="new_car_invoice_date"
        :value="form.new_car_invoice_date"
        label="新车开票日期"
      />
      <van-field
        v-model="form.new_car_invoice_location"
        :disabled="disabled"
        label="新车发票开具地"
      />
      <van-field
        :disabled="disabled"
        name="new_car_regist_date"
        :value="form.new_car_regist_date"
        label="新车注册登记日期"
      />
      <van-field
        v-model="form.new_car_model_no"
        :disabled="disabled"
        name="new_car_model_no"
        label="新车车辆型号"
      />
      <van-field
        v-model="form.new_car_regist_location"
        :disabled="disabled"
        label="新车注册登记地"
      />
      <van-field v-model="form.photo_new_car_invoice" name="photo_new_car_invoice" label="新车购车发票照片" :disabled="disabled" >
        <template #input>
          <div class="upload-icon" >
            <van-image class="upload-icon" :src="form.photo_new_car_invoice" @click="preview(form.photo_new_car_invoice)">
            </van-image>
          </div>
        </template>
      </van-field>
      <van-field v-model="form.photo_new_car_regist" name="photo_new_car_regist" label="新车机动车登记证书" :disabled="disabled" >
        <template #input>
          <div class="upload-icon">
            <van-image class="upload-icon" :src="form.photo_new_car_regist" @click="preview(form.photo_new_car_regist)">
            </van-image>
          </div>
        </template>
      </van-field>
      
  </div>
</template>
<script>
import axios from 'axios'
import { util } from '../../assets/common2.js'
import { ImagePreview } from 'vant'
export default {
  name: 'CarOldForNewDetail',
  props: {
  },
  data () {
    return {
      form_id: null,
      loading: false,
      form: {},
      disabled: true
    }
  },
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
    // CommentComponent
  },
  computed: {
  },
  created: function () {
    if (util.inWechat()) {
      this.$router.push('/car/index')
    }
    this.form_id = this.$route.params.form_id
  },
  mounted: function () {
    this.getDetail()
  },
  methods: {
    preview(img) {
      ImagePreview([img])
    },
    getDetail() {
      util.Arequest((data) => {
        var formData = new FormData()
        formData.append('token',data.token)
        axios.post(`/encrypt3/form/detail?form_id=${this.form_id}&userid=${data.userid}&fid=${this.$store.state.fid}`,formData).then(res => {
            if (res.data.msg == 'ok') {
              this.form = res.data.form
              this.loading = false;
            } else if (res.data.msg == 'not admin') {
              this.$toast('无权限')
            } else if (res.data.msg == 'not exists') {
              this.$toast('没有该申请')
            } else if (res.data.msg == 'error merchant') {
              this.$toast('非法请求')
            } else {
              this.$toast('网络繁忙\n稍后重试')
            } 
          })
      })
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .main {
  margin-top: 56.3vw;
} */
.reject-reason {
  background-color: aqua;
}
</style>
